import React, { memo } from 'react';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import styles from './styles.module.scss';

/** Figma / ROAR-4314: clear “error” glyph in the circular badge (not a close mark). */
const ErrorIcon = () => (
  <div className={`${styles.error} flex items-center justify-center`}>
    <ErrorOutline sx={{ fontSize: 40, color: '#fff' }} />
  </div>
);

export default memo(ErrorIcon);
